import { combineReducers, createStore } from 'redux';
import alertP450Reduers from '../reducers/alertsForP450'

const reducers = combineReducers({
    alertP450: alertP450Reduers,
})


export default createStore(reducers);